export default "icons-menu-hamburger"